<template>
    <span>
        <div class="world-map-section">
        </div>


        <!-- Begin:Content:KeyDestinations -->
        <sdr-keydestinations modulo="flightplan"></sdr-keydestinations>
        <!-- End:Content:KeyDestinations -->


        <!-- Begin:Content:FlightplanTable -->
        <sdr-flightplantable @clickdepartureairport="onClick_DepartureAirportInFlightplanTable" @clickresetmap="onClick_ResetMap"></sdr-flightplantable>
        <!-- End:Content:FlightplanTable -->


        <!-- Begin:PromoBox -->
        <!-- <sdr-promobox-bremen></sdr-promobox-bremen> -->
        <sdr-promobox-sundair-app></sdr-promobox-sundair-app>
        <!-- End:PromoBox -->
    </span>
</template>

<script>
    import KeyDestinations from '../booking/pagecontent/KeyDestinations.vue'; // Content
    import FlightplanTable from '../flightplan/pagecontent/FlightplanTable.vue'; // Content
    import PromoBoxBremen from '../booking/pagecontent/PromoBoxBremen.vue';
    import PromoBoxSundairApp from '../booking/pagecontent/PromoBoxSundairApp.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    import VueScrollTo from 'vue-scrollto';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-keydestinations': KeyDestinations,
            'sdr-flightplantable': FlightplanTable,
            'sdr-promobox-bremen': PromoBoxBremen,
            'sdr-promobox-sundair-app': PromoBoxSundairApp,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> -----------------------------
                mallorca_txt: {
                    en: 'The coruscant sea, white beaches and and a wonderful heartland full of impressing nature and culinary pleasures. No wonder that this	Balearic island is one of the most favoured destinations in summer.',
                    de: 'Funkelndes Meer, weiße Strände und ein Landesinnere, das mit wundervoller Natur und kulinarischen Genüssen beeindruckt. Nicht umsonst erfreut sich die Baleareninsel einer so hohen Beliebtheit als Sommerreiseziel.',
                },
                antalya_txt: {
                    en: 'Discover Turkey at its best. There is probably no other metropolis that boom like the provincial capital Antalya. Antalya stands for holiday, sun, beach and the bustle of a city.',
                    de: 'Erleben Sie die Türkei von ihrer schönsten Seite. Kaum eine türkische Metropole boomt wie die Provinzhauptstadt Antalya. Antalya - das ist Urlaub, Antalya - das ist Sonne, Strand und Großstadttrubel.',
                },
                beirut_txt: {
                    en: '„Paris of the Middle East“. The capital of Lebanon represents the economic and cultural center of the country. Traditional and modern spirit flow together in this city and provide the chance to delve into the history and the busting atmosphere of Beirut.',
                    de: '"Paris des Nahen Ostens“. Die Hauptstadt des Libanon stellt das wirtschaftliche und kulturelle Zentrum des Landes dar. Tradition und Moderne treffen hier aufeinander und geben Ihnen die Möglichkeit, in die Geschichte und die lebendige Atmosphäre dieser Stadt einzutauchen.',
                },
                burgas_txt: {
                    en: 'Burgas offers the perfect chance to connect relaxing beach holidays with the cultural environment of a busting city. Make an excursion to the antique settlements next to this beautiful seaport or enjoy the romantic landscape and the nearby national park.',
                    de: 'Burgas ist die perfekte Gelegenheit, um einen entspannenden Strandurlaub mit dem kulturellen Angebot einer lebendigen Großstadt zu verbinden. Besuchen Sie die antiken Siedlungen rund um die schöne Hafenstadt oder genießen Sie die romantische Seenlandschaft und den nahegelegenen Naturschutzpark.',
                },
                fuerteventura_txt: {
                    en: 'Fuerteventura is the ideal choice for all sun worshipper and water sports enthusiasts. Endless sandy beaches in the south, cliffy hillslopes, lonely bays and quaint villages characterize this island.',
                    de: 'Fuerteventura ist die ideale Urlaubsinsel für alle Sonnenanbeter und Wassersportler. Markenzeichen sind die endlosen feinsandigen Strände im Süden, schroffe Berghänge, einsame Buchten und idyllische Dörfer.',
                },
                grancanaria_txt: {
                    en: 'Gran Canaria makes all of your holiday dreams come true: Relax by sunbathing at one of the wonderful sandy beaches or hike along the pinewood. Also water sports enthusiasts and reveler will find perfect foundations for a great time at this sunny island.',
                    de: 'Gran Canaria bietet Ihnen alles, was das Urlauberherz begehrt: Entspannen Sie beim Sonnenbaden an den hellen Sandstränden oder wandern Sie durch die weiten Kiefernwälder. Auch Wassersportler und Nachtschwärmer kommen auf der Sonneninsel garantiert auf ihre Kosten.',
                },
                heraklion_txt: {
                    en: 'This island offers a fascinating combination of nature and culture together with gorgeous beaches, high mountains, deep canyons and up to 300 sunny days a year. Nearby the city there are the ruins of the palace of Knossos – a fascinating destination not only for the fans of culture.',
                    de: 'Die Insel bietet eine faszinierende Kombination aus Natur und Kultur mit traumhaften Stränden, hohen Berge und tiefen Schluchten und rund 300 Sonnentage im Jahr. Ganz in der Nähe befinden sich die Ruinen des Palastes von Knossos – ein spannendes Reiseziel nicht nur für Kultur-Liebhaber.',
                },
                hurghada_txt: {
                    en: 'May you be in search of an adventure in the desert, a trip to the beach or fascinating history – Egypt is a destination that inspires the heart and the spirit.',
                    de: 'Sei es ein Wüstenabenteuer, ein Strandausflug oder das Eintauchen in die faszinierende Geschichte – Ägypten ist das Ziel, das in Herz und Geist den Funken der Inspiration entzündet!',
                },
                kos_txt: {
                    en: 'Kos is the third largest island of the Dodecanese islands and has a total area of 290 km². Just like Rhodes this island is almost everywhere covered with green vegetation and offers long sandy beaches and a spirited capital city.',
                    de: 'Kos ist mit einer Gesamtfläche von rund 290 km² die drittgrößte Insel der Dodekanes und genau wie Rhodos eine überwiegend grüne Insel mit langen Sandstränden und einer lebhaften Hauptstadt.',
                },
                marsaalam_txt: {
                    en: 'Marsa Alam is one of the most favored destinations for relaxing holidays at the beach of the Red Sea. Discover the colourful diversity of the coral reefs and shoals along the coast or go on an excursion and visit the impressing desert.',
                    de: 'Direkt am Roten Meere gelegen ist Marsa Alam eines der beliebtesten Ferienziele für einen Badeurlaub in Ägypten. Entdecken Sie beim Schnorcheln die farbenfrohe Vielfalt der Riffe und Fischschwärme entlang der Küste oder machen Sie einen Ausflug in die beeindruckende Wüstenlandschaft.',
                },
                rhodos_txt: {
                    en: 'Rhodes is the island of flowers. At the east coast a lot of long beaches and bays invite you to take a bath, at the west coast you will find a very impressing steep coast. Not only geographically but also humanely Rhodes lays between orient and occident.',
                    de: 'Die Blumeninsel. An der Ostküste laden viele lange Strände und Buchten zum Baden ein, die zerklüftete Westküste beeindruckt durch die imposante Steilküste. Nicht nur geographisch, sondern auch menschlich gesehen, liegt Rhodos zwischen dem Orient und dem Okzident.',
                },
                teneriffa_txt : {
                    en: 'If you are looking for everlasting spring with plenty of sun and warmth and a beautiful blooming nature, Teneriffa is the island you are looking for. The largest of the Canary Islands stands for a breathtaking diversity that offers new discoveries every single day.',
                    de: 'Wer den ewigen Frühling sowie ausgeglichenes Klima mit reichlich Sonne und Wärme sucht und wer Freude an der Schönheit der blühenden Natur hat, wird von Teneriffa nicht enttäuscht sein. Die größte der Kanarischen Inseln bietet eine atemberaubende Vielfalt, sodass jeder Tag eine neue Entdeckung bereithält.',
                },
                varna_txt : {
                    en: 'Varna offers the perfect conditions for an unforgettable vacation: pleasant climate and ample sandy beaches. Visit the third largest city of Bulgaria and get in touch with the impressing history of this metropolis',
                    de: 'Varna bietet mit seinem angenehmen Klima und seinen weitläufigen Sandstränden beste Voraussetzungen für einen unvergesslichen Urlaub. Besuchen Sie Bulgariens drittgrößte Stadt und tauchen Sie ein in die Geschichte dieser beeindruckenden Metropole.',
                },
                corfu_txt : {
                    en: 'Let yourself be enchanted by an island which, due to its Mediterranean climate, has a truly impressive diversity of species and is unparalleled. Corfu has something for everyone.',
                    de: 'Lassen Sie sich verzaubern von einer Insel, die aufgrund des mediterranen Klimas eine wahrhaft imposante Artenvielfalt aufweist und ihresgleichen sucht. Korfu hat für jeden etwas zu bieten.',
                },
                lanzarote_txt : {
                    en: 'Long and lonely beaches, friendly people, a wide range of leisure activities and first-class accommodation guarantee an unforgettable vacation.',
                    de: 'Lange und einsame Strände, freundliche Menschen, ein breitgefächertes Freizeitangebot und erstklassige Unterkünfte garantieren ein unvergesslichen Urlaub.',
                }
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Maps & Infoboxes (at Startup).
        * Note:
        *
        */
        mounted: function() {

            var me = this;


            me.$toc('>>> booking/flightplan/Home.vue >>> mounted');
            setTimeout(function() {
                me.initMap('start');
            }, 600);

        },  // eof mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Map Utilities'
            * Map Utilities:
            *******************************************************************/
            /*******************************************************************
            * initMap()
            *
            * Desc:
            * Note: Weve got _SUMMER_19, _WINTER_19_20, _SUMMER_20
            *
            * @param {String} type ('The Departure Airport')
            */
            initMap(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> initMap');
                // >>> --------------------------------------------------------- Which Marker(s)?
                switch(type) {
                    // >>> -------------------
                    case 'start':
                        values = me.map_Start();
                        break;
                    // >>> -------------------
                    case 'TXL_SUMMER_19':
                    case 'TXL_WINTER_19_20':
                    case 'TXL_SUMMER_20':
                        values = me.map_From_TXL(type);
                        break;
                    // >>> -------------------
                    case 'KSF_SUMMER_19':
                    case 'KSF_WINTER_19_20':
                    case 'KSF_SUMMER_20':
                    case 'KSF_WINTER_21':
                        values = me.map_From_KSF(type);
                        break;
                    // >>> -------------------
                    case 'DRS_SUMMER_19':
                    case 'DRS_WINTER_19_20':
                    case 'DRS_SUMMER_20':
                    case 'DRS_WINTER_21':
                        values = me.map_From_DRS(type);
                        break;
                    // >>> -------------------
                    case 'BRE_SUMMER_19':
                    case 'BRE_WINTER_19_20':
                    case 'BRE_SUMMER_20':
                    case 'BRE_WINTER_21':
                        values = me.map_From_BRE(type);
                        break;
                    // >>> -------------------
                    case 'BER_WINTER_21':
                        values = me.map_From_BER(type);
                        break;
                    // >>> -------------------
                    case 'DUS_WINTER_21':
                        values = me.map_From_DUS(type);
                        break;
                    // >>> -------------------
                    default:
                        trnsltdType = '';
                }


                // >>> ---------------------------------------------------------
                tjq(".world-map-section").gmap3({
                    map:{
                        options: {
                            center:[46.578498,2.457275],
                            zoom: 4,
                            mapTypeId: google.maps.MapTypeId.HYBRID,
                            mapTypeControl: true,
                        }
                    },
                    marker:{
                        values: values,
                        options: {
                            draggable: false,
                            animation: google.maps.Animation.DROP
                        },
                        events: {
                            click: function(marker, event, context) {
                                if (infobox.getPosition() == marker.getPosition() && mapDiv.find(".infoBox").length > 0) {
                                    infobox.close();
                                } else {
                                    map.panTo(marker.getPosition());
                                    infobox.setContent(context.data);
                                    infobox.open(map,marker);
                                    // if map is small
                                    var iWidth = 405;
                                    var iHeight = 165;
                                    if((mapDiv.width() / 2) < iWidth ) {
                                        var offsetX = iWidth - (mapDiv.width() / 2);
                                        map.panBy(offsetX, 0);
                                    }

                                    if((mapDiv.height() / 2) < iHeight ) {
                                        var offsetY = -(iHeight - (mapDiv.height() / 2));
                                        map.panBy(0, offsetY);
                                    }
                                    setTimeout(function() {
                                        tjq(".infoBox .middle-block").middleblock();
                                    }, 200);
                                }


                                if (marker.getAnimation() !== null) {
                                    marker.setAnimation(null);
                                } else {
                                    marker.setAnimation(google.maps.Animation.BOUNCE);
                                }
                            }
                        }
                    }
                });


                // >>> ---------------------------------------------------------
                var mapDiv = tjq(".world-map-section");
                var map = mapDiv.gmap3("get");
                var infobox = new InfoBox({
                    pixelOffset: new google.maps.Size(-204, -78),
                    closeBoxURL: '',
                    enableEventPropagation: true
                });
                mapDiv.delegate('.infoBox .close','click', function () {
                    infobox.close();
                });

            }, // eof initMap()


            /*******************************************************************
            * clearMap()
            *
            * Desc:
            * Note:
            *
            */
            clearMap() {

                let me = this;

                me.$toc('>>> /flightplan/Home.vue >>> clearMap');
                tjq(".world-map-section").gmap3({
                    clear: {
                        name:["marker", "circle"],
                        // last: true
                    }
                });

            }, // eof clearMap()




            /******************************************************************* 'Maps/Markers'
            * Maps/Markers Building:
            *******************************************************************/
            /*******************************************************************
            * map_Start()
            *
            * Desc: Map, At Startup, All Marker are shown.
            * Note:
            *
            */
            map_Start() {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_Start');
                // http://maps.google.com/mapfiles/marker_green.png
                // https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png
                return values = [
                    { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE() }, // Fuerteventura (FUE) (key)
                    { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA() }, // Gran Canaria (LPA) (key)
                    { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER() }, // Heraklion (HER) (key)
                    { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI() }, // Mallorca (PMI) (key)
                    { latLng:[36.89259, 27.28779], data: me.buildInfoBox_KGS() }, // Kos (KGS) (key)
                    { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS() }, // Teneriffa (TFS) (key)
                    { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO() }, // Rhodos (RHO) (key)
                    { latLng:[42.50479, 27.46264], data: me.buildInfoBox_BOJ() }, // Burgas (BOJ) (key)

                    { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY() }, // Beirut (BEY)
                    { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG() }, // Hurghada (HRG)
                    { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT() }, // Antalya (AYT)
                    { latLng:[25.06763, 34.87897], data: me.buildInfoBox_RMF() }, // Marsa Alam (RMF)
                    { latLng:[43.21405, 27.91473], data: me.buildInfoBox_VAR() }, // Varna (VAR)

                    { latLng:[39.62498, 19.92235], data: me.buildInfoBox_CFU() }, // Corfu (CFU)

                    { latLng:[28.97015, -13.53905], data: me.buildInfoBox_ACE() }, // Lanzarote (ACE)
                ];

            }, // eof map_Start()


            /*******************************************************************
            * map_From_TXL()
            *
            * Desc: Map, Destinations starting in TXL. (all in)
            * Note: Weve got _SUMMER_19, _WINTER_19_20, _SUMMER_20
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_TXL(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_TXL');
                if (type === 'TXL_SUMMER_19') {
                    values = [
                        { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Beirut (BEY)
                        { latLng:[42.50479, 27.46264], data: me.buildInfoBox_BOJ(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Burgas (BOJ)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                    ];
                }

                if (type === 'TXL_WINTER_19_20') {
                    values = [
                        { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Beirut (BEY)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[25.06763, 34.87897], data: me.buildInfoBox_RMF(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Marsa Alam (RMF)
                    ];
                }

                if (type === 'TXL_SUMMER_20') {
                    values = [
                        { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Beirut (BEY)
                        { latLng:[42.50479, 27.46264], data: me.buildInfoBox_BOJ(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Burgas (BOJ)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[36.89259, 27.28779], data: me.buildInfoBox_KGS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Kos (KGS) (key)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                        { latLng:[43.21405, 27.91473], data: me.buildInfoBox_VAR(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Varna (VAR)
                    ];
                }

                return values;

            }, // eof map_From_TXL()


            /*******************************************************************
            * map_From_BER()
            *
            * Desc: Map, Destinations starting in BER. (all in)
            * Note: Weve got BER_WINTER_21
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_BER(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_BER');
                if (type === 'BER_WINTER_21') {
                    values = [
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Beirut (BEY)
                    ];
                }


                return values;

            }, // eof map_From_BER()


            /*******************************************************************
            * map_From_DUS()
            *
            * Desc: Map, Destinations starting in DUS. (all in)
            * Note: Weve got DUS_WINTER_21
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_DUS(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_DUS');
                if (type === 'DUS_WINTER_21') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                        { latLng:[33.89379, 35.50178], data: me.buildInfoBox_BEY(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Beirut (BEY)
                        { latLng:[28.97015, -13.53905], data: me.buildInfoBox_ACE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Lanzarote (ACE)
                    ];
                }


                return values;

            }, // eof map_From_DUS()


            /*******************************************************************
            * map_From_KSF()
            *
            * Desc: Map, Destinations starting in KSF.
            * Note: Weve got _SUMMER_19, _WINTER_19_20, _SUMMER_20
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_KSF(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_KSF');
                if (type === 'KSF_SUMMER_19') {
                    values = [
                        { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Antalya (AYT)
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Mallorca (PMI)
                    ];
                }

                if (type === 'KSF_WINTER_19_20') {
                    values = [
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }

                if (type === 'KSF_SUMMER_20') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Mallorca (PMI)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                    ];
                }

                if (type === 'KSF_WINTER_21') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }


                return values;

            }, // eof map_From_KSF()


            /*******************************************************************
            * map_From_DRS()
            *
            * Desc: Map, Destinations starting in DRS.
            * Note: Weve got _SUMMER_19, _WINTER_19_20, _SUMMER_20
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_DRS(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_DRS');
                if (type === 'DRS_SUMMER_19') {
                    values = [
                        { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Antalya (AYT)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[36.89259, 27.28779], data: me.buildInfoBox_KGS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Kos (KGS)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                    ];
                }

                if (type === 'DRS_WINTER_19_20') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[25.06763, 34.87897], data: me.buildInfoBox_RMF(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Marsa Alam (RMF)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }

                if (type === 'DRS_SUMMER_20') {
                    values = [
                        { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Antalya (AYT)
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[36.89259, 27.28779], data: me.buildInfoBox_KGS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Kos (KGS)
                        { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Mallorca (PMI)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                        { latLng:[43.21405, 27.91473], data: me.buildInfoBox_VAR(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Varna (VAR)
                        { latLng:[39.62498, 19.92235], data: me.buildInfoBox_CFU(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Corfu (CFU)
                    ];
                }

                if (type === 'DRS_WINTER_21') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }


                return values;

            }, // eof map_From_DRS()


            /*******************************************************************
            * map_From_BRE()
            *
            * Desc: Map, Destinations starting in BRE.
            * Note: Weve got _SUMMER_19, _WINTER_19_20, _SUMMER_20
            *
            * @param {String} type ('The Departure Airport')
            */
            map_From_BRE(type) {

                let me = this,
                    values = [];


                me.$toc('>>> /flightplan/Home.vue >>> map_From_BRE');
                if (type === 'BRE_SUMMER_19') {
                    values = [
                        { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Antalya (AYT)
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Mallorca (PMI)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                    ];
                }

                if (type === 'BRE_WINTER_19_20') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[25.06763, 34.87897], data: me.buildInfoBox_RMF(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Marsa Alam (RMF)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }

                if (type === 'BRE_SUMMER_20') {
                    values = [
                        { latLng:[36.89689, 30.71332], data: me.buildInfoBox_AYT(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Antalya (AYT)
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[35.33874, 25.14421], data: me.buildInfoBox_HER(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Heraklion (HER)
                        { latLng:[36.89259, 27.28779], data: me.buildInfoBox_KGS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Kos (KGS)
                        { latLng:[39.56960, 2.65016], data: me.buildInfoBox_PMI(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Mallorca (PMI)
                        { latLng:[36.43496, 28.21748], data: me.buildInfoBox_RHO(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Rhodos (RHO)
                    ];
                }

                if (type === 'BRE_WINTER_21') {
                    values = [
                        { latLng:[28.485554, -14.027663], data:  me.buildInfoBox_FUE(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Fuerteventura (FUE)
                        { latLng:[27.25790, 33.81161], data: me.buildInfoBox_HRG(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Hurghada (HRG)
                        { latLng:[28.12355, -15.43626], data: me.buildInfoBox_LPA(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Gran Canaria (LPA)
                        { latLng:[28.46363, -16.25185], data: me.buildInfoBox_TFS(), options:{ icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" } }, // Teneriffa (TFS)
                    ];
                }



                return values;

            }, // eof map_From_BRE()




            /******************************************************************* 'Infoboxes'
            * Infoboxes Building:
            *******************************************************************/
            /******************************************************************* 'Fuerteventura (FUE)' (key) (text)
            * buildInfoBox_FUE()
            *
            * Desc: Build InfoBox Fuerteventura (FUE)
            * Note:
            *
            */
            buildInfoBox_FUE() {

                let me = this,
                    fueHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_FUE');
                // >>> Fuerteventura (FUE) -------------------------------------
                return fueHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/fue_fuerteventura_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Fuerteventura (FUE)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.fuerteventura_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_FUE()


            /******************************************************************* 'Gran Canaria (LPA)' (key) (text)
            * buildInfoBox_LPA()
            *
            * Desc: Build InfoBox, Gran Canaria (LPA)
            * Note:
            *
            */
            buildInfoBox_LPA() {

                let me = this,
                    lpaHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_LPA');
                // >>> Gran Canaria (LPA) --------------------------------------
                return lpaHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/lpa_grancanaria_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Gran Canaria (LPA)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.grancanaria_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_LPA()


            /******************************************************************* 'Heraklion (HER)' (key) (text)
            * buildInfoBox_HER()
            *
            * Desc: Build InfoBox, Heraklion (HER)
            * Note:
            *
            */
            buildInfoBox_HER() {

                let me = this,
                    herHtmlBox = '';

                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_HER');
                // >>> Heraklion (HER) -----------------------------------------
                return herHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/her_heraklion_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Heraklion (HER)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                                + me.heraklion_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_HER()


            /******************************************************************* 'Mallorca (PMI)' (key) (text)
            * buildInfoBox_PMI()
            *
            * Desc: Build InfoBox, Mallorca (PMI)
            * Note:
            *
            */
            buildInfoBox_PMI() {

                let me = this,
                    pmiHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_PMI');
                // >>> Mallorca (PMI) ------------------------------------------
                return pmiHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/pmi_mallorca_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Mallorca (PMI)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                             + me.mallorca_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_PMI()


            /******************************************************************* 'Kos (KGS)' (key) (text)
            * buildInfoBox_KGS()
            *
            * Desc: Build InfoBox, Kos (KGS)
            * Note:
            *
            */
            buildInfoBox_KGS() {

                let me = this,
                    kgsHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_KGS');
                // >>> Kos (KGS) -----------------------------------------------
                return kgsHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/kos_kos_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Kos (KOS)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                                + me.kos_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_KGS()


            /******************************************************************* 'Teneriffa (TFS)' (key) (text)
            * buildInfoBox_TFS()
            *
            * Desc: Build InfoBox, Teneriffa (TFS)
            * Note:
            *
            */
            buildInfoBox_TFS() {

                let me = this,
                    tfsHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_TFS');
                // >>> Teneriffa (TFS) -----------------------------------------
                return tfsHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/tfs_teneriffa_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Teneriffa (TFS)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                                + me.teneriffa_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_TFS()


            /******************************************************************* 'Rhodos (RHO)' (key) (text)
            * buildInfoBox_RHO()
            *
            * Desc: Build InfoBox, Rhodos (RHO)
            * Note:
            *
            */
            buildInfoBox_RHO() {

                let me = this,
                    rhoHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_RHO');
                // >>> Rhodos (RHO) --------------------------------------------
                return rhoHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/rho_rhodos_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Rhodos (RHO)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                                + me.rhodos_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_RHO()


            /******************************************************************* 'Burgas (BOJ)' (key) (text)
            * buildInfoBox_BOJ()
            *
            * Desc: Build InfoBox, Burgas (BOJ)
            * Note:
            *
            */
            buildInfoBox_BOJ() {

                let me = this,
                    bojHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_BOJ');
                // >>> Burgas (BOJ) --------------------------------------------
                return bojHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/boj_burgas_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Burgas (BOJ)</h4>
                                    <div class="table-wrapper">
                                        <div class="table-row">
                                            <div class="table-cell">`
                                                + me.burgas_txt[this.getCurrentLocale] +
                                            `</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_BOJ()



            /******************************************************************* 'Beirut (BEY)' (text)
            * buildInfoBox_BEY()
            *
            * Desc: Build InfoBox, Beirut (BEY)
            * Note:
            *
            */
            buildInfoBox_BEY() {

                let me = this,
                    beyHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_BEY');
                // >>> Beirut (BEY) --------------------------------------------
                return beyHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/bey_beirut_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Beirut (BEY)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.beirut_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_BEY()


            /******************************************************************* 'Hurghada (HRG)' (text)
            * buildInfoBox_HRG()
            *
            * Desc: Build InfoBox, Hurghada (HRG)
            * Note:
            *
            */
            buildInfoBox_HRG() {

                let me = this,
                    hrgHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_HRG');
                // >>> Hurghada (HRG) ------------------------------------------
                return hrgHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/hrg_hurghada_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Hurghada (HRG)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.hurghada_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_HRG()


            /******************************************************************* 'Antalya (AYT)' (text)
            * buildInfoBox_AYT()
            *
            * Desc: Build InfoBox, Antalya (AYT)
            * Note:
            *
            */
            buildInfoBox_AYT() {

                let me = this,
                    aytHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_AYT');
                // >>> Antalya (AYT) -------------------------------------------
                return aytHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/ayt_antalya_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Antalya (AYT)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.antalya_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_AYT()


            /******************************************************************* 'Marsa Alam (RMF)' (text)
            * buildInfoBox_RMF()
            *
            * Desc: Build InfoBox, Marsa Alam (RMF)
            * Note:
            *
            */
            buildInfoBox_RMF() {

                let me = this,
                    rmfHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_RMF');
                // >>> Marsa Alam (RMF) ----------------------------------------
                return rmfHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/rmf_marsaalam_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Marsa Alam (RMF)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.marsaalam_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_RMF()


            /******************************************************************* 'Varna (VAR)' (text)
            * buildInfoBox_VAR()
            *
            * Desc: Build InfoBox, Varna (VAR)
            * Note:
            *
            */
            buildInfoBox_VAR() {

                let me = this,
                    varHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_VAR');
                // >>> Marsa Alam (RMF) ----------------------------------------
                return varHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/var_varna_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Varna (VAR)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.varna_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_VAR()


            /******************************************************************* 'Corfu (CFU)' (text)
            * buildInfoBox_CFU()
            *
            * Desc: Build InfoBox, Corfu (CFU)
            * Note:
            *
            */
            buildInfoBox_CFU() {

                let me = this,
                    varHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_CFU');
                // >>> Corfu (CFU) ---------------------------------------------
                return varHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/cfu_corfu_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Korfu (CFU)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.corfu_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_CFU()


            /******************************************************************* 'Lanzarote (ACE)' (text)
            * buildInfoBox_ACE()
            *
            * Desc: Build InfoBox, Lanzarote (ACE)
            * Note:
            *
            */
            buildInfoBox_ACE() {

                let me = this,
                    varHtmlBox = '';


                me.$toc('>>> /flightplan/Home.vue >>> buildInfoBox_ACE');
                // >>> Lanzarote (ACE) ---------------------------------------------
                return varHtmlBox = `
                    <div class="marker-holder">
                        <div class="image-box">
                            <figure class="middle-block"><img src="/res/images/keydestinations/ace_lanzarotte_270x160.png" alt="" class="middle-item"></figure>
                            <div class="details"><span class="close">X</span>
                                <h4 class="title">Lanzarote (ACE)</h4>
                                <div class="table-wrapper">
                                    <div class="table-row">
                                        <div class="table-cell">`
                                            + me.lanzarote_txt[this.getCurrentLocale] +
                                        `</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

            }, // eof buildInfoBox_ACE()




            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_DepartureAirportInFlightplanTable()
            *
            * Desc:
            * Note: Listening to Event Emitter from Child Component.
            *
            * @param {Object} e ('The Departure Airport')
            */
            onClick_DepartureAirportInFlightplanTable(e) {

                let me = this,
                    options = {
                        container: 'body',
                        easing: 'linear',
                        offset: -60,
                        force: true,
                        cancelable: true,
                        onStart: function(element) {
                            // scrolling started
                        },
                        onDone: function(element) {
                            // scrolling is done
                        },
                        onCancel: function() {
                            // scrolling has been interrupted
                        },
                        x: false,
                        y: true
                    };


                me.$toc('>>> /flightplan/Home.vue >>> onClick_DepartureAirportInFlightplanTable');
                me.$scrollTo('#scrollPointTop', 200, options);
                me.clearMap();

                setTimeout(function(){
                    me.initMap(e.depairport);
                }, 500);

            }, // eof onClick_DepartureAirportInFlightplanTable()


            /*******************************************************************
            * onClick_ResetMap()
            *
            * Desc:
            * Note: Listening to Event Emitter from Child Component.
            *
            */
            onClick_ResetMap(e) {

                let me = this,
                    options = {
                        container: 'body',
                        easing: 'linear',
                        offset: -60,
                        force: true,
                        cancelable: true,
                        onStart: function(element) {
                            // scrolling started
                        },
                        onDone: function(element) {
                            // scrolling is done
                        },
                        onCancel: function() {
                            // scrolling has been interrupted
                        },
                        x: false,
                        y: true
                    };


                me.$toc('>>> /flightplan/Home.vue >>> onClick_ResetMap');
                me.$scrollTo('#scrollPointTop', 200, options);
                me.clearMap();

                setTimeout(function(){
                    me.initMap('start');
                }, 300);

            }, // eof onClick_ResetMap()

        }, // eof methods()
        /* <<< ****************************************************************/

    };

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/flightplan/Home.vue